import React from 'react'

const PricingTable = ({ pricePerSlot, tableText }) => {
  const curentPipe = value => {
    return `£${value.toFixed(2)}`
  }

  return (
    <div className="pricing-container" style={{ display: 'flex', flexDirection: 'column' }}>
      <p>{tableText}</p>
      <table>
        <thead>
          <tr>
            <th>Number of e-Learning Module(s)</th>
            <th>Number of Slots Needed</th>
            <th>Cost (£)</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>1-5</td>
            <td>1</td>
            <td>{curentPipe(pricePerSlot)}</td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export default PricingTable
